import { BookOpen, Users } from "lucide-react";
import { useEffect, useState } from "react";
import { School, ChartArea } from "lucide-react";
import AddClass from "./AddClass";
import DeleteClass from "./DeleteClass";

function EnglishClassesOverview({ classesvalue }) {
  const [totalStudents, setTotalStudents] = useState(0);
  const [selectStudent, setSelectStudent] = useState(0);
  useEffect(() => {
    if (classesvalue) {
      const total = classesvalue.reduce(
        (acc, value) => acc + value.students.length,
        0,
      );
      // console.log(total);
      // veya state'e kaydedebilirsiniz.
      setTotalStudents(total);
    }
  }, [classesvalue]); // classesvalue değiştiğinde tekrar hesaplamak için bağımlılık dizisine ekleyin.
  const handleCreateHomework = (count) => {
    setSelectStudent(count);
  };
  const totalClasses = classesvalue.length;
  const classButtons = [
    {
      title: "Sınıfların İstatistikler",
      icon: ChartArea,
      count: 0,
      bg: "bg-purple-500 hover:bg-yellow-500 ",
    },
    {
      title: "Yeni Sınıf Oluştur",
      icon: School,
      count: 1,
      bg: "bg-purple-500 hover:bg-yellow-500 ",
    },
  ];
  return (
    <div className="min-h-screen bg-white p-4 md:p-6 rounded-2xl">
      <div className="max-w-7xl mx-auto">
        {/* Başlık Bölümü */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-2xl font-semibold text-gray-600 mb-2">
            your Classes
          </h1>
          <p className="text-gray-600 max-w-3xl mx-auto text-sm md:text-base">
            2., 3. ve 4. sınıf İngilizce derslerinin genel durumu, ödev takibi
            ve konu ilerleyişi
          </p>
        </div>

        {/* Genel İstatistikler - Responsive */}
        <div className="flex flex-col justify-center gap-6 md:gap-8 ">
          <div className="flex justify-center gap-10">
            <div className="bg-gray-100 rounded-xl p-4 md:p-6 shadow-lg flex-1 max-w-xs">
              <div className="flex items-center justify-center md:justify-between">
                <div className="text-center md:text-left">
                  <div className="text-2xl text-center md:text-3xl font-bold text-purple-600">
                    {totalStudents}
                  </div>
                  <div className="text-gray-600 font-medium text-sm md:text-base  md:block">
                    Toplam Öğrenci
                  </div>
                </div>
                <div className="p-2 md:p-3 bg-purple-500 rounded-full ml-2 md:ml-0">
                  <Users className="w-6 h-6 md:w-8 md:h-8 text-white" />
                </div>
              </div>
            </div>
            <div className="bg-gray-100 rounded-xl p-4 md:p-6 shadow-lg flex-1 max-w-xs">
              <div className="flex items-center justify-center md:justify-between">
                <div className="text-center md:text-left">
                  <div className="text-2xl text-center  md:text-3xl font-bold text-purple-600">
                    {totalClasses}
                  </div>
                  <div className="text-gray-600 font-medium text-sm md:text-base  md:block">
                    Aktif Sınıf
                  </div>
                </div>
                <div className="p-2 md:p-3 bg-purple-500 rounded-full ml-2 md:ml-0">
                  <BookOpen className="w-6 h-6 md:w-8 md:h-8 text-white" />
                </div>
              </div>
            </div>
          </div>
          <div className=" flex gap-4 justify-center items-center">
            {classButtons.map((button, index) => (
              <button
                key={index}
                onClick={() => handleCreateHomework(button.count)}
                className={`${button.bg} text-white px-4 py-2 rounded-xl
                transition-all duration-300  text-md
              transform hover:scale-105 flex items-center space-x-3 mx-auto`}
              >
                <div className="flex flex-col lg:flex-row gap-1 lg:items-center lg:justify-center">
                  <div className="flex justify-center items-center-safe">
                    <button.icon className=" w-6 h-6 " />
                  </div>
                  <span className="text-xs lg:text-md">{button.title}</span>
                </div>
              </button>
            ))}
          </div>
          <hr className="border-2 border-yellow-500 my-2" />
          <div>
            {selectStudent === 0 && <DeleteClass classList={classesvalue} />}
            {selectStudent === 1 && (
              <AddClass
                capacity={null}
                classTitle={null}
                classDescription={null}
                classId={null}
              />
            )}
            {/* {selectStudent === 2 && <DeleteClass classList={classesvalue} />} */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EnglishClassesOverview;
